import axios from 'lib/axios'
import {
  CreateReportTemplateRequest,
  DuplicateReportTemplateRequest,
  ListTemplatesParams,
  PaginatedReportTemplatesResponse,
  ReportResponse,
  ReportTemplateNameExistsResponse,
  ReportTemplateResponse,
  StartReportScheduleRequest,
  UpdateReportTemplateRequest,
  ValidateTemplateConfigResponse
} from 'models'

const basePath = '/api/v4/reports/templates'

export const ReportTemplateService = {
  createTemplate: async (request: CreateReportTemplateRequest): Promise<ReportTemplateResponse> => {
    const { data } = await axios.post(basePath, request)
    return data
  },

  listTemplates: async (params?: ListTemplatesParams): Promise<PaginatedReportTemplatesResponse> => {
    const { data } = await axios.get(`${basePath}/list`, { params })
    return data
  },

  getTemplate: async (templateId: string): Promise<ReportTemplateResponse> => {
    const { data } = await axios.get(`${basePath}/${templateId}`)
    return data
  },

  updateTemplate: async (
    templateId: string,
    request: UpdateReportTemplateRequest
  ): Promise<ReportTemplateResponse> => {
    const { data } = await axios.put(`${basePath}/${templateId}`, request)
    return data
  },

  deleteTemplate: async (templateId: string): Promise<void> => {
    await axios.delete(`${basePath}/${templateId}`)
  },

  duplicateTemplate: async (
    templateId: string,
    request: DuplicateReportTemplateRequest
  ): Promise<ReportTemplateResponse> => {
    const { data } = await axios.post(`${basePath}/${templateId}/duplicate`, request)
    return data
  },

  createReportFromTemplate: async (templateId: string): Promise<ReportResponse> => {
    const { data } = await axios.post(`${basePath}/${templateId}/create`)
    return data
  },

  validateTemplate: async (templateId: string): Promise<ValidateTemplateConfigResponse> => {
    const { data } = await axios.post(`${basePath}/${templateId}/validate`)
    return data
  },

  checkNameExists: async (
    name: string,
    excludeTemplateId?: string
  ): Promise<ReportTemplateNameExistsResponse> => {
    const { data } = await axios.get(`${basePath}/name-exists`, {
      params: { name, exclude_template_id: excludeTemplateId }
    })
    return data
  },

  startSchedule: async (
    templateId: string,
    request: StartReportScheduleRequest
  ): Promise<ReportTemplateResponse> => {
    const { data } = await axios.post(`${basePath}/${templateId}/schedule`, request)
    return data
  },

  stopSchedule: async (templateId: string): Promise<ReportTemplateResponse> => {
    const { data } = await axios.delete(`${basePath}/${templateId}/schedule`)
    return data
  }
}
